/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import { PageSettings } from "../../config/page-settings";
import { Step, Stepper } from "react-form-stepper";
import PersonalInformation from "./PersonalInformation";
import HousingInformation from "./HousingInformation";
import References from "./References";
import EmploymentHistory from "./EmploymentHistory";
import logo from "../../assets/img/logo/AniaLogo-full.svg";
import Agreement from "./Agreement";
import { useDispatch, useSelector } from "react-redux";
import { GetCarInfoAction } from "../../redux/actions/parking";
import { useTranslation } from "react-i18next";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
} from "reactstrap";
import { createWebQueue, updateWebQueue, finishQueue, saveAndComeBackLater } from "../../redux/actions/webqueue";
import { useHistory, useLocation } from "react-router-dom";

const OnBoardTenantFromOffice = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const context = useContext(PageSettings);
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [form, setForm] = useState({});
  // Office walk-in has no record until the first form save. Once created, this
  // holds the LobbyQueue zzID the rest of the flow (PATCH / signature / finish)
  // keys on — mirroring the route `:_id` the web flow gets for free.
  const [zzID, setZzID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("i18nextLng") === "es" ? "Spanish" : "English"
  );
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const [isAllowedLoading, setIsAllowedLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mainMenu = queryParams.get("mainMenu");

  const styleConfig = {
    activeBgColor: "#007cba",
    completedBgColor: "#00acac",
  };

  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    checkIP();
  }, []);

  const checkIP = async ()=> {
    try {
      setIsAllowed(true);
      dispatch(GetCarInfoAction());
      // setIsAllowedLoading(true)
      // const result = await dispatch(checkIPAction());
      // setIsAllowed(result?.allow);
      // if(result?.allow === true){
      //    dispatch(GetCarInfoAction());
      // }
    } catch (error) {
      console.log(error);
    }finally{
      setIsAllowedLoading(false)
    }
  }

  const toggle = () => {
    setDropDownOpen(!dropDownOpen);
  };

  // Create the record on the first save, then PATCH on later saves. Returns the
  // zzID (creating + remembering it if not yet created). Throws on failure.
  const persistForm = async () => {
    const details = { ...form };
    if (!details.Car) details.Car = "No";
    if (zzID) {
      await dispatch(updateWebQueue(zzID, { details }));
      return zzID;
    }
    const created = await dispatch(createWebQueue({ details }));
    const id = created?.zzID;
    if (!id) throw new Error("Failed to create application record");
    setZzID(id);
    return id;
  };

  const handleNavigation = async (direction, navigate = true, signature = null) => {
    if (direction === "previous") {
      setActiveStep(activeStep > 0 ? activeStep - 1 : 0);
      return;
    }
    if (direction === "next") {
      setLoading(true);
      try {
        await persistForm();
        if (navigate) {
          setActiveStep(activeStep < 4 ? activeStep + 1 : activeStep);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
      return;
    }
    if (direction === "documents") {
      // Final step (Agreement): the signature was already uploaded to S3 + the
      // FM container by Agreement via uploadSignature(zzID). Finalize the
      // application — /finish flips Type → "Rental Application",
      // RecordAccess_State → "NJ", Status → "Submitted". Office flow has no
      // document uploads, so only the finish request is needed.
      setLoading(true);
      try {
        await dispatch(finishQueue(zzID));
        history.replace("/thank-you?startNew=true&mainMenu=true");
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
      return;
    }
    if (direction === "save-and-come-back") {
      setLoading(true);
      try {
        // Save the current form data, then email the applicant a link to resume
        // the application from home. persistForm() returns the zzID (creating the
        // record on the first step if needed).
        const id = await persistForm();
        await dispatch(saveAndComeBackLater(id));
        history.replace("/thank-you?startNew=true&mainMenu=true");
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
      return;
    }
  };

  const renderLanguageMenu = () => {
    return (
      <Dropdown
        isOpen={dropDownOpen}
        toggle={toggle}
        className="dropdown navbar-languager"
      >
        <DropdownToggle className="dropdown-toggle" tag="a">
          <span
            className={`flag-icon ${
              selectedLanguage === "Spanish" ? `flag-icon-es` : `flag-icon-us`
            } m-r-5`}
          ></span>
          <span className="name d-none d-sm-inline">{selectedLanguage}</span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu dropdown-menu-right">
          <DropdownItem
            onClick={(e) => {
              setSelectedLanguage("English");
              i18n.changeLanguage("en");
            }}
          >
            <span className="flag-icon flag-icon-us m-r-5"></span> English
          </DropdownItem>
          <DropdownItem
            onClick={(e) => {
              setSelectedLanguage("Spanish");
              i18n.changeLanguage("es");
            }}
          >
            <span className="flag-icon flag-icon-es m-r-5"></span> Spanish
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const renderApplicationContent = () => {
    return (
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-sm-4 col-xl-3 col-12">
            <img src={logo} alt="" />
          </div>
          <div className="col-sm-8 col-xl-9 col-12">
            <div className="row align-items-center justify-content-end">
              <div className="col-sm-3 col-xl-2 col-4 pt-2 pt-sm-0 d-flex align-items-center justify-content-end">
                {renderLanguageMenu()}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <Stepper activeStep={activeStep}>
              <Step
                label={t("tenantApp.personal_info")}
                styleConfig={styleConfig}
              />
              <Step
                label={t("tenantApp.housing_infor")}
                styleConfig={styleConfig}
              />
              <Step
                label={t("tenantApp.references")}
                styleConfig={styleConfig}
              />
              <Step
                label={t("tenantApp.employment")}
                styleConfig={styleConfig}
              />
              <Step
                label={t("tenantApp.agreement")}
                styleConfig={styleConfig}
              />
            </Stepper>
          </div>
        </div>
        {activeStep === 0 ? (
          <PersonalInformation
            handleNavigation={handleNavigation}
            form={form}
            setForm={(e) => setForm(e)}
            loading={loading}
            hideSave={true}
            mainMenu={mainMenu}
          />
        ) : activeStep === 1 ? (
          <HousingInformation
            handleNavigation={handleNavigation}
            form={form}
            setForm={(e) => setForm(e)}
            loading={loading}
            hideSave={true}
            mainMenu={mainMenu}
          />
        ) : activeStep === 2 ? (
          <References
            handleNavigation={handleNavigation}
            form={form}
            setForm={(e) => setForm(e)}
            loading={loading}
            hideSave={true}
            mainMenu={mainMenu}
          />
        ) : activeStep === 3 ? (
          <EmploymentHistory
            handleNavigation={handleNavigation}
            form={form}
            setForm={(e) => setForm(e)}
            loading={loading}
            hideSave={true}
            mainMenu={mainMenu}
          />
        ) : activeStep === 4 ? (
          <Agreement
            handleNavigationForOffice={handleNavigation}
            queueId={zzID}
            form={form}
            setForm={(e) => setForm(e)}
            mainLoading={loading}
            hideSave={true}
            mainMenu={mainMenu}
          />
        ) : null}
      </div>
    );
  };

  const renderIPCheck = ()=>{
    return <div className="w-100 vh-100 d-flex align-items-center justify-content-center">
      {!isAllowed && isAllowedLoading === false && <p className="text-center fs-1" style={{fontSize: 24}}>You are not allowed to access this page.</p>}
      {isAllowedLoading === true && <p className="text-center " style={{fontSize: 24}}>Please Wait...</p>}
    </div>
  }

  return !isAllowed || isAllowedLoading === true ? renderIPCheck() : renderApplicationContent();
};

export default OnBoardTenantFromOffice;
